




































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Direction } from "@/enums";
import { Cell } from "@/models";

@Component
export default class CellComponent extends Vue {
  @Prop() public cell!: Cell;
  get up() {
    return Direction.Up;
  }
  get down() {
    return Direction.Down;
  }
  get left() {
    return Direction.Left;
  }
  get right() {
    return Direction.Right;
  }
  move(direction: Direction) {
    this.$emit("move", this.cell, direction);
  }
}
